// extracted by mini-css-extract-plugin
export default {"box":"DevelopersPage_box__mvR51","img":"DevelopersPage_img__4l67i"};